// removed by extract-text-webpack-plugin
module.exports = {"edgeView":"_1FX1XGt6tE9pmIZz","removeContainer":"cPA_MGx_Il7Ddmz8","remove":"_2y7ikb_Vm0FHmhMT","icon":"QYpQn6cVfGzfZAvm","pathHoverArea":"Wm-9Kdt15JE2Bk_l","svgContainer":"MZ3rrngJus6shJD7","path":"_2Xk6l0Sw2cWbjYl5","highlighted":"Hqe_rnvqlZ5I_Nx3"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/EdgeView/EdgeView.pcss
// module id = 500
// module chunks = 1